import VueRouter from "vue-router";
import store from "./store/index";

// let cofocus = true;

/* ====== ROUTE SPLITTING & LAZY LOADING OPTIMIZATION!!! ====== */
/* https://vueschool.io/articles/vuejs-tutorials/vue-js-router-performance/ */

/* DO NOT IMPORT OUTSIDE ACCESSING ROUTE UNLESS VERY VERY GOOD REASON
SEEK BEST POSSIBLE OPTIMIZATION, ALWAYS, OR I WILL HAUNT YOU IN YOUR SLEEP. */

/* ====== AUTH PAGES ====== */
// import SuccessPage from "./pages/AuthPages/SuccessPage";

let routes = [
  /* ====== COFOCUS PROFILE ROUTES ====== */

  // {
  //   path: "/profile/:userID",
  //   redirect: "/profile/:userID/"
  // },

  {
    path: "/admin/:section",
    component: () => import("./ELYX/AdminDashboard/AdminDashboard"),
    meta: {
      requireAuthentication: true,
      adminAccessRequired: true,
    },
  },

  {
    path: "/statistics",
    component: () => import("./ELYX/Statistics/Statistics"),
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/affiliate-dashboard",
    component: () => import("./ELYX/AffiliateDashboard/AffiliateDashboard"),
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/profiles/:username",
    component: () => import("./ELYX/Profiles/Profile"),
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/homespace",
    component: () => import("./ELYX/Homespace/Homespace"),
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/day",
    component: () => import("./ELYX/Day/Day"),
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/slider",
    component: () => import("./ELYX/ELYSIA/PageSlider"),
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/profile/:userID/:profileTab?",
    component: () => import("./pages/ProfilePages/Profile"),
    name: "Profile",
    meta: {
      requireAuthentication: true,
      isProfile: true,
    },
  },

  /* ====== COFOCUS BOOKING ROUTES ====== */
  {
    path: "/dashboard/booking",
    component: () => import("./pages/BookingPages/BookingDashboard"),
    name: "BookingDashboard",
    meta: {
      requireAuthentication: true,
      calendar: true,
    },
  },

  {
    path: "/dashboard/changelog",
    component: () => import("./pages/InfoPages/Changelog"),
    name: "Changelog",
    meta: {
      requireAuthentication: true,
    },
  },

  {
    path: "/dashboard/announcements",
    component: () => import("./pages/InfoPages/Blog.vue"),
    name: "Blog",
    meta: {
      requireAuthentication: true,
    },
  },

  /* ====== COFOCUS SESSION ROUTES ====== */

  {
    path: "/session/:sessionID",
    component: () => import("./pages/RoomPages/Room"),
    name: "RoomPage",
    meta: {
      sessionPage: true,
      hideNavigation: true,
      isSession: true,
      customTimer: true,
      session: true,
    },
  },

  /* ====== COFOCUS LANDING ROUTES ====== */

  {
    path: "/",
    component: () => import("./pages/Cofocus/Home"),
    meta: {
      landingPage: true,
      calendar: true,
    },
    name: "Home",
  },

  {
    path: "/usecases",
    component: () => import("./pages/Cofocus/UseCases"),
    meta: {
      landingPage: true,
    },
    name: "UseCases",
  },

  {
    path: "/pricing",
    component: () => import("./pages/Cofocus/Pricing"),
    meta: {
      landingPage: true,
      newLandingPage: true,
    },
    name: "Pricing",
  },

  {
    path: "/affiliate-program",
    component: () => import("./pages/Cofocus/AffiliateProgram"),
    meta: {
      landingPage: true,
      newLandingPage: true,
    },
    name: "AffiliateProgram",
  },

  {
    path: "/about",
    component: () => import("./pages/InfoPages/About"),
    name: "About",
    meta: {
      isPublic: true,
    },
  },

  /* ====== GROUP ROUTES ====== */

  {
    path: "/communities/:communityURL",
    component: () => import("./pages/CommunityPages/CommunityPage"),
    name: "CommunityPage",
    meta: {
      isCommunity: true,
      communityPage: true,
      discussion: true,
    },
  },

  {
    path: "/communities/:communityURL/:communityArea",
    component: () => import("./pages/CommunityPages/CommunityPage"),
    meta: {
      isCommunity: true,
      communityPage: true,
      requireAuthentication: true,
    },
  },

  {
    path: "/communities/:communityURL/posts/:postID",
    component: () => import("./pages/CommunityPages/CommunityPage"),
    meta: {
      isCommunity: true,
      communityPage: true,
      requireAuthentication: true,
    },
  },

  /* ====== AUTHENTICATION ROUTES ====== */
  {
    path: "/account/login",
    component: () => import("./pages/AuthPages/LoginPage"),
    name: "LoginPage",
    meta: {
      loginPage: true,
    },
  },
  {
    path: "/account/logout",
    component: () => import("./pages/AuthPages/LogoutPage"),
    name: "LogoutPage",
  },
  {
    path: "/account/register",
    component: () => import("./pages/Cofocus/Register"),
    name: "RegisterPage",
    meta: {
      registerPage: true,
    },

    // children: [{ path: "success", component: SuccessPage, name: "Success" }],
  },

  {
    path: "/signup/onboarding",
    component: () => import("./pages/Cofocus/RegisterFlow"),
    name: "RegisterFlow",
    meta: {
      hideNavigation: true,
      onboarding: true,
    },
  },

  {
    path: "/account/verify/:token",
    component: () => import("./pages/AuthPages/VerificationPage"),
    name: "VerificationPage",
    meta: {
      hideNavigation: true,
      onboarding: true,
    },
  },
  {
    path: "/account/resetpassword/:token",
    component: () => import("./pages/AuthPages/PassResetRedirectPage"),
    name: "PassResetRedirectPage",
  },
  {
    path: "/account/passreset",
    component: () => import("./pages/AuthPages/PassResetPage"),
    name: "PassResetPage",
  },

  {
    path: "/account/forgotpass",
    component: () => import("./pages/AuthPages/ForgotPass"),
    name: "ForgotPass",
  },

  {
    path: "/account/verify",
    component: () => import("./pages/AuthPages/VerifyPage"),
    name: "VerifyPage",
  },

  /* ========== INFORMATION PAGES ========== */

  {
    path: "/unsubscribe",
    component: () => import("./ELYX/Unsubscribe/Unsubscribe"),
    name: "Unsubscribe",
    meta: {
      isPublic: true,
    },
  },

  {
    path: "/information/:page",
    component: () => import("./pages/InfoPages/Policy"),
    name: "Policy",
    meta: {
      isPublic: true,
    },
  },

  {
    path: "/information/terms",
    component: () => import("./pages/InfoPages/Terms"),
    name: "Terms",
  },

  {
    path: "/information/privacy",
    component: () => import("./pages/InfoPages/PrivacyPolicy"),
    name: "PrivacyPolicy",
  },

  {
    path: "/information/acceptableuse",
    component: () => import("./pages/InfoPages/AcceptableUse"),
    name: "AcceptableUse",
  },

  {
    path: "/information/cookiepolicy",
    component: () => import("./pages/InfoPages/CookiePolicy"),
    name: "CookiePolicy",
  },

  {
    path: "/information/cancellationpolicy",
    component: () => import("./pages/InfoPages/CancellationPolicy"),
    name: "CancellationPolicy",
  },

  {
    path: "/information/contact",
    component: () => import("./pages/InfoPages/Contact"),
    name: "Contact",
    meta: {
      isPublic: true,
    },
  },

  {
    path: "/help/:page",
    component: () => import("./components/Widgets/InfoModal/InfoPages/GuideBase"),
    name: "GuideBase",
    meta: {
      isPublic: true,
    },
  },

  {
    path: "/help/community-guidelines",
    component: () => import("./components/Widgets/InfoModal/InfoPages/CommunityGuidelines"),
    name: "CommunityGuidelines",
    meta: {
      isPublic: true,
    },
  },

  {
    path: "/help/safety-on-cofocus",
    component: () => import("./components/Widgets/InfoModal/InfoPages/SafetyOnCofocus"),
    name: "SafetyOnCofocus",
    meta: {
      isPublic: true,
    },
  },

  {
    path: "/survey/:surveyID",
    component: () => import("./apps/Survey/Survey.vue"),
    name: "Survey",
    meta: {
      isPublic: true,
    },
  },

  /* ========== MASTERS OF MEDALS ========== */

  {
    path: "/lordofthemedals",
    component: () => import("./pages/Lords/LordOfTheMedal"),
    meta: {
      requireAuthentication: true,
    },
  },

  /* ========== TASKS/NOTES APP ========== */

  /* {
    path: "/notesapp",
    component: () => import("./apps/Note/Notes"),
    meta: {
      requireAuthentication: true,
    },
  }, */
  {
    path: "/journal",
    component: () => import("./ELYX/Notespace/Notespace"),
    meta: {
      requireAuthentication: true,
    },
  },
  {
    path: "/spaces/home",
    component: () => import("./ELYX/Spaces/Space"),
    meta: {
      requireAuthentication: true,
    },
  },

  /* ========== DASHBOARD APP ========== */
  {
    path: "/dashboard",
    component: () => import("./apps/Dashboard/Dashboard"),
    meta: {
      requireAuthentication: true,
    },
  },

  // /* ====== DEVELOPER ROUTES ====== */
  // {
  //   path: "/developer/logs",
  //   component: () => import("./pages/DeveloperPages/LogDashboard"),
  //   meta: {
  //     requireAuthentication: true,
  //     requireVerification: true,
  //   }
  // },
  /* ====== ERROR ROUTES ====== */
  {
    path: "/errors/error",
    component: () => import("./pages/ErrorPages/ErrorPage"),
    name: "ErrorPage",
  },

  {
    path: "/errors/404",
    name: "Error404Page",
    component: () => import("./pages/ErrorPages/Error404Page"),
  },

  { path: "*", redirect: "/errors/404" },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

/**
 * Goal: Avoid calling next twice or you end up with infinite loop
 * Check for public, auth & sign up flow pages, all else is private pages
 *
 * NB! Make sure to include *all* non-private pages (except landing)
 * in the authPages & publicPages arrays. Alternatively, add these
 * to the meta of the pages.
 */
const authPages = ["LoginPage", "RegisterPage", "ForgotPass"];
const publicPages = ["PrivacyPolicy", "Terms", "UseCases", "Pricing", "AffiliateProgram"];
const resetPassPages = ["PassResetRedirectPage", "PassResetPage"];

router.beforeEach(async (to, from, next) => {
  /* console.log("name", to.name); */
  if (!store.state.auth.ready) {
    try {
      await store.dispatch("auth/authenticate");
    } catch (err) {
      console.error("@router err: ", err);
    }
  }

  const authenticated = store.state.auth.authenticationStatus;
  let verified = store.state.auth.verificationStatus;
  if (store.state.auth.user && store.state.auth.user.verificationStatus) {
    verified = store.state.auth.user.verificationStatus;
  }
  let displayName = null;
  if (store.state.auth.user && store.state.auth.user.displayName) {
    displayName = store.state.auth.user.displayName;
  }

  if (publicPages.includes(to.name) || to.meta.isPublic) {
    next();
  } else if (authenticated) {
    if (verified && displayName) {
      if (authPages.includes(to.name) || to.name == "RegisterFlow" || to.name == "VerificationPage") {
        next("/");
      } else if (to.meta && to.meta.adminAccessRequired) {
        const admins = ["5ffa95888d24191c09f7f0bb", "609e51f7a601860015b41871"];
        const userHasAdminAccess = admins.includes(store.state.auth.user._id);
        if (userHasAdminAccess) {
          next();
        } else {
          next("/");
        }
      } else if (to.name == "Home") {
        next();
      } else {
        next();
      }
    } else if (!verified && !displayName) {
      if (to.name == "RegisterFlow" || to.name == "VerificationPage") {
        next();
      } else if (to.name == "Home") {
        next({ name: "RegisterFlow" });
      } else {
        next({ name: "RegisterFlow" });
      }
    } else if (verified && !displayName) {
      if (to.name == "RegisterFlow") {
        next();
      } else if (to.name == "Home" || to.name == "VerificationPage") {
        next({ name: "RegisterFlow" });
      } else {
        next({ name: "RegisterFlow" });
      }
    } else if (!verified && displayName) {
      // Should never happen as sign up process does not
      // allow for entering displayName before being verified.
      if (to.name == "RegisterFlow") {
        next();
      } else if (to.name == "Home" || to.name == "VerificationPage") {
        next({ name: "RegisterFlow" });
      } else {
        next({ name: "RegisterFlow" });
      }
    }
  } else if (!authenticated) {
    if (authPages.includes(to.name) || resetPassPages.includes(to.name) || to.name == "Home" || to.name == "VerificationPage") {
      next();
    } else if (to.name == "RegisterFlow") {
      if (to.query && to.query.verified) {
        /* Purpose is to pack info to show success message once lands on LoginPage */
        router.push({
          name: "LoginPage",
          query: { verified: true },
        });
        /* window.location = "/account/login" + "?verified=true"; */
      } else {
        next({ name: "LoginPage" });
      }
    } else {
      next({ name: "LoginPage" });
    }
  }
});

export default router;
